export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/admin-79014ed66bbb3f9c2e02963871ccafec.jpg";